








































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Axios, { AxiosResponse } from "axios";
import { BFormTextarea, BForm } from "bootstrap-vue";
@Component({
  components: {
    BForm,
    BFormTextarea,
  },
})
export default class Publish extends Vue {
  protected email = "";
  protected message = "";
  protected answer = "";

protected form() {
  // On envoie un objet JavaScript classique, Axios va automatiquement le convertir en JSON
  const payload = {
    email: this.email,
    message: this.message
  };

  Axios.post("/php/form.php", payload)
    .then((response: AxiosResponse) => {
      // Attention : ton PHP renvoie un objet JSON {status: "...", message: "..."}
      // On l'affiche dynamiquement ici
      if (response.data.status === "success") {
        this.answer = response.data.message; // "Votre message a été envoyé."
        this.email = "";
        this.message = "";
      } else {
        this.answer = response.data.message; // Affiche l'erreur renvoyée par le PHP
      }
    })
    .catch((error) => {
      console.error("Erreur d'envoi :", error);
      this.answer = "Erreur lors de l'envoi.";
    });
}
}
